// Publications data lives in JSON (editable by humans, scripts, n8n).
// Validated against PublicationsSchema at module load.
import { PublicationsSchema, type Publications } from '@lib/schemas/publication';
import data from './data/publications.json';

export const publications: Publications = PublicationsSchema.parse(data);
